export default {
  //SubMenu
  clientsList: "Klanten lijst",
  collaborators: "Bijdragers",
  myDashboard: "Mijn Dashboard",
  collaboratorSpace: "Bijdrager gebied",
  myBalanceSheet: "Mijn balans",
  dashboardsModels: "Dashboard-sjablonen",
  slidesModels: "Diasjablonen",
  presentation: "Presentatie",
  //HEADER
  slidesList: "dia's lijst",
  collaboratorList: "Lijst met medewerkers",
  templatesDashboard: "DASHBOARD-SJABLONEN",
  //Subheaders
  clientsListSubHeader: "bekijk en beheer uw klantrecords",
  slidesListSubHeader: "visualiseer en beheer uw dia's",
  collaboratorListSubHeader: "Vind alle medewerkers.",
  templatesDashboardSubHeader: "visualiseer en beheer uw dashboards",
  balanceSheetSubHeader: "GEDETAILLEERD FINANCIEEL GEZONDHEIDSZICHT",

  //Actions
  add: "Toevoegen",
  use: "Kies een extra dia",
  post: "posten",
  send: "versturen",
  read: "lezen",
  edit: "Bewerk",
  exit: "Uitgang",
  save: "Besparen",
  hide: "zich verstoppen",
  play: "Speel",
  apply: "Toepassen",
  cancel: "Annuleren",
  import: "Import",
  delete: "Verwijderen",
  update: "Bewerken",
  return: "Terugkeer",
  logout: "uitloggen",
  search: "Zoeken",
  sortBy: "Sorteren op",
  goBack: "Ga terug",
  seeAll: "Alles zien",
  prepare: "Bereiden",
  validate: "Bevestigen",
  associate: "associëren",
  duplicate: "duplicaat",
  explore: "Ontdekken",
  selectAll: "selecteer alles",
  deselectAll: "Deselecteer alles",
  signIn: "Aanmelden / Inschrijven",
  generate: "Genereren",
  regenerate: "Regenereren",
  showMore: "laat meer zien",
  addToCalendar: "Toevoegen aan agenda",
  //Label
  to: "tot",
  the: "de",
  year: "Jaar",
  next: "Volgend",
  previous: "Voorgaand",
  filter: "Filter",
  client: "Cliënt",
  ratiosOf: "Verhoudingen van",
  admin: "Beheerder",
  error: "Fout",
  rendezVous: "Afspraak",
  caution: "Voorzichtigheid",
  balanceSheetOf: "Balans van",
  typeOfEnterprise: "Type onderneming",
  juridicalForm: "Juridische vorm",
  diaporama: "slideshow",
  unknown: "onbekend",
  closingDate: "Sluitingsdatum",
  duration: "Duur",
  startDate: "begin datum",
  endDate: "Einddatum",
  dateRange: "datumbereik",
  createdAt: "Gemaakt bij",
  updatedAt: "Bijgewerkt op",
  increaseOf: "opkomst van",
  decreaseOf: "druppel van",
  inferior: "lager",
  superior: "hoger",
  average: "gemiddeld",
  allCategories: "Alle categorieën",
  files: "bestanden",
  settings: "instellingen",
  communities: "Gemeenschappen",
  TAMTAMApplications: "TAMTAM-toepassingen",
  Event: "Evenement",
  Survey: "Enquête",
  profile: "Profiel",
  preview: "voorvertoning",
  title: "Titel",
  content: "Inhoud",
  visibility: "zichtbaarheid",
  visible: "zichtbaar",
  me: "Mij",
  indicator: "Indicator",
  indicators: "indicatoren",
  nbrOfYears: "Aantal jaren",
  maxValue: "maximum waarde",
  minValue: "Min waarde",
  annexeCategory: "Bijlage categorie",
  annexeYear: "bijlage Jaar",
  fileName: "Bestandsnaam",
  category: "Categorie",
  importedAt: "Geïmporteerd bij",
  action: "Actie",
  role: "rol",
  roles: "rollen",
  recipients: "ontvangers",
  recipient: "ontvanger",
  categories: "categorieën",
  all: "Alle",
  today: "vandaag",
  yesterday: "gisteren",
  otherday: "andere dag",
  week: "week",
  comments: "opmerkingen",
  hidden: "Verborgen",
  certified: "gecertificeerd",
  main: "Hoofd",
  configuration: "Configuratie",
  authorizations: "autorisaties",
  newUser: "Nieuwe gebruiker",
  users: "gebruikers",
  user: "Gebruiker",
  editor: "Uitgever",
  total: "totaal",
  as: "zoals",
  and: "en",
  sentTo: "verzonden naar",
  justSent: "net verzonden",
  resendAgain: "stuur nogmaals",
  preferences: "Voorkeuren",
  recentActivities: "recente activiteiten",
  clientFolders: "klantenmappen",
  configuredFolders: "Geconfigureerde mappen",
  noAnnexesFolders: "Bestanden zonder bijlagen",
  noConfiguredFolders: "Niet-geconfigureerde mappen",
  noActivities: "geen activiteiten",
  noOptions: "aucune option",
  relizedDuration: "relized duur",
  traitMyFolders: "Eigenschap mijn mappen",
  clientIndicator: "Klantindicator",
  exercise: "Oefening",
  home: "Ontvangst",
  none: "geen",
  mutation: "mutatie",
  financial: "financieel",
  treasury: "schatkist",
  annexes: "bijlagen",
  status: "toestand",
  view: "visie",
  lastImport: "Laatste import",
  folder: "Dossier",
  extraSlideDescription:
    "Dia's met notities die u kunt invoeren, aanpassen en toevoegen aan de presentatie.",
  remerciementDescription:
    'Dia met een bedankbriefje, "Bedankt voor uw aandacht", een avatar van de manager met zijn voornaam, achternaam, e-mailadres en mobiel nummer.',
  questionsDescription:
    'Dia met een verzoek als de klant vragen heeft, "Heeft u nog vragen?".',
  finalDateValidationLink: "Geldig tot",
  periodValidationLink: "Geldigheidsduur van de link :",
  monday: "Maandag",
  tuesday: "Dinsdag",
  wednesday: "Woensdag",
  thursday: "Donderdag",
  friday: "Vrijdag",
  saturday: "Zaterdag",
  sunday: "Zondag",
  myFolders: "Mijn bestanden",
  myPresentations: "Mijn presentaties",
  by: "door",
  private: "Privaat",
  public: "Publique",
  duplicated: "Gedupliceerd",
  original: "Origineel",
  share: "Delen",
  standard: "standaard",
  created: "Gemaakt",
  toUse: "Gebruiken",
  frozen: "Bevroren",
  sharedWithCommunity: "Gedeeld met community",
  slide: "dia",
  yes: "ja",
  no: "nee",
  new: "Nieuwe",
  editableTemplate: "Bewerkbare sjabloon",
  //Titles
  library: "bibliotheek",
  myTemplates: "My templates",
  slideView: "Diavoorbeeld",
  createSlideTemplate: "diasjabloon maken",
  createDashboardTemplate: "dashboardsjabloon maken",
  noLegalForms: "Geen rechtsvormen",
  presentations: "Presentaties",
  clientType: "klant type (CRM)",
  clientGroup: "Klantengroep (CRM)",
  inSomeFigures: "In sommige nummers",
  affectedModel: "Betrokken model",
  clientForm: "Klantenkaart",
  manageAssociations: "Koppelingen beheren",
  managerSpace: "Managerruimte",
  manageExplanation: "Beheer uitleg",
  manageCategories: "Categorieën beheren",
  addExplanation: "Voeg een toelichting toe",
  addExplanations: "Voeg uitleg toe",
  addRecipients: "Ontvangers toevoegen",
  addEmailTemplates: "E-mailtemplates toevoegen",
  typeExplanations: "Typ uw uitleg (3 talen beschikbaar)",
  associationLegalForm: "Associatie dashboard / rechtsvorm",
  dashboardcreated: "Dashboards-modellen gemaakt",
  dashboardstandard: "Standaard Dashboards-modellen",
  associateClientTitle: "Cliënten koppelen aan hoofddashboard",
  companyNaturalPerson: "Onderneming natuurlijke persoon",
  companyLegalPerson: "Onderneming rechtspersoon",
  profitability: "Winstgevendheid",
  solvency: "Solvabiliteit",
  liquidity: "Liquiditeit",
  balanceSheet: "Balans",
  configureOrganization: "Configuratie van de organisatie",
  exercisesConfiguration: "Oefeningen configuratie",
  dashboard: "Dashboard",
  dashboardPrincipal: "dashboard opdrachtgever",
  slideConfigurationPage: "Schuif configuratie",
  slideTitle: "dia titel",
  slideBackgroundColor: "Achtergrond kleur",
  slideComponentColor: "Component kleur",
  slideLayoutTitle: "Opmaak wijzigen",
  componentsList: "componenten lijst",
  componentConfig: "Component configuratie",
  createdSlides: "Gemaakte dia's",
  standardSlides: "Standaard dia's",
  allSlides: "Alle dia's",
  titleDuplicateSlide: "Dia dupliceren",
  titleAddSlide: "dia toevoegen",
  titleUseSharedSlide: "Gebruik deze dia",
  titleAddDashboard: "dashboard toevoegen",
  titleUseSharedDashboard: "Dashboard gebruiken",
  addPresenter: "Een presentator toevoegen",
  importCustomerBalance: "Importeer de schaal van de klant",
  dashboardComposition: "Dashboardsamenstelling",
  slideComposition: "dia Samenstelling",
  configuredExercises: "Geconfigureerde oefeningen",
  importedBalances: "Geïmporteerde schalen",
  updateCategory: "Categorie bewerken",
  createCategory: "Categorie aanmaken",
  addComment: "Voeg een reactie toe ...",
  moveSlideTemplate: "Verplaats de dia-sjabloon",
  addSlideTemplate: "Voeg een dia-sjabloon in na de huidige dia",
  switchSlideTemplate: "Vervang de huidige dia door een dia-sjabloon",
  chooseERP: "Kies de ERP",
  chooseModel: "Kies het model",
  undefinedVAT: "Le numéro de TVA n'est pas défini",
  titleDuplicateDashboard: "dubbel dashboard",
  attacherAnnexeCategorie: "bijgevoegde categoriebijlage ",
  descriptionExercisesModel: "Beschrijving van het oefenmodel",
  yearOfExercise: "Jaar van oefening",
  MultipleYearsModel: "Meerdere modellen",
  FiveYearsModel: "5 jaar model",
  TwoYearsModel: "2 jaar model",
  OneYearModel: "1 jaar model",
  comparedModel: "Vergelijkend oefenmodel",
  winbooksModel: "1 jaar model",
  importAnnexes: "Bijlagen import",
  importBalance: "Balans importeren",
  importCustomerAnnexe: "Import van bijlagen van klanten",
  seeMore: "Bekijk meer",
  otherUser: "Andere gebruiker(s)",
  chooseCategory: "Keuze van categorie",
  chooseYear: "Kies Jaar",
  selectCommunity: "kies uw community",
  categoriesList: "Categorieën lijst",
  explanationsList: "lijst met verklaringen",
  HiddenAnnex: "Verborgen bijlage",
  VisibleAnnex: "Zichtbare bijlage",
  extraSlides: "extra dia's",
  annexState: "Annex Staat",
  newSlide: "Nieuwe slide",
  newDashboard: "Nieuw dashboard",
  useAModele: "Gebruik een model",
  slidePosition: "schuif Positie",
  ajouterExtraSlideTitle: "extra dia toevoegen",
  editExtraSlideTitle: "Extra dia bewerken",
  titleModalCategory: "Creëer of wijzig categorieën",
  chooseExtraSLide: "Choose an Extra Slide",
  dashboardYear: "Dashboard van het jaar",
  categoryList: "Lijst met categorieën",
  addExtaSLide: "voeg een extra dia toe",
  addExercise: "Oefening toevoegen",
  removeExercise: "Verwijder oefening",
  associateClient: "associëren met het dashboard",
  updateExplanation: "Bewerk een uitleg",
  undefinedPresentationDate: "Presentatiedatum niet ingesteld",
  presentationNotPrepared: "Onvoorbereide presentatie",
  presentationDone: "Presentatie gemaakt",
  preparedPresentation: "Presentatie voorbereid",
  readyPresentation: "Presentatie prête",
  notPrepared: "niet voorbereid",
  prepared: "bereid",
  presented: "gepresenteerd",
  synchronized: "Klanten met een gesynchroniseerde balans",
  presentedThe: "Gepresenteerd op",
  toPresenteThe: "presenteren",
  frExplanation: "franse uitleg",
  enExplanation: "Engelse uitleg",
  nlExplanation: "Nederlandse uitleg",
  processing: "Verwerken",
  frTitle: "Franse Titel",
  enTitle: "Engelse Titel",
  nlTitle: "Nederlandse titel",
  externalLinks: "Externe links",
  notConfigured: "Niet geconfigureerd",
  undefinedDate: "Ongedefinieerde datum",
  noAnnexes: "Geen bijlagen",
  withAnnexe: "met bijlagen",
  notCompleted: "Niet compleet",
  completed: "voltooid",
  accountingRoles: "Accounting rollen",
  organizationRoles: "Organisatierollen",
  dashboardPrivileges: "dashboardrechten",
  associatePrivileges: "geassocieerde privileges",
  allowCreateDashboard: "Autorisatie van het dashboard",
  allowCreateSlide: "Dia maken toestaan",
  allowUpdateDashboard: "Bewerken van dashboard toestaan",
  allowUpdateSlide: "Wijziging van dia's toestaan",
  allowAccessDashboard: "Toegang tot dashboardlijst toestaan",
  allowAccessCollaborator: "Toegang tot de lijst met medewerkers autoriseren",
  allowAccessParameters: "Toegang tot de lijst met parameters toestaan",
  allowAccessSlide: "Toegang tot de lijst met dia's toestaan",
  allowAssociateDashboards: "Dashboard-koppeling toestaan",
  parameterPrivileges: "Parameterrechten",
  companyDateCreation: "Datum van oprichting van het bedrijf",
  presentationPreparation: "Voorbereiding op de presentatie van het jaar",
  preparationPresention: "Voorbereiding van de presentatie",
  creationDashboard: "Dashboard maken",
  creationSlide: "Dia's maken",
  saveFinish: "Opslaan en voltooien",
  makeVisible: "Zichtbaar maken",
  addCategory: "Voeg een categorie",
  clientVisibility: "klantzichtbaarheid",
  organizationState: "organisatiestatus",
  datePresentation: "Datum presentatie",
  linkGenered: "Link gegenereerd",
  linkNotGenered: "Link niet gegenereerd",
  presentationLink: "Presentatielink",
  feedbackRequest: "Feedbackverzoek",
  sendRequest: "Verzend verzoek",
  sendLink: "Stuur link",
  sendAppointment: "Afspraak verzenden",
  addNew: "Nieuwe toevoegen",
  sendToAddress: "Verzenden naar adres",
  refresh: "Standaardfilter toepassen",
  presentationExtraSlide: "Extra slides van de presentatie",
  slideRemerciement: "dank je dia",
  slideQuestions: "vraag dia",
  linkPresentation: "Deelbare link van de presentatie",
  titleSharedDashboard: "Dashboard delen",
  titleSharedSlide: "Dia delen",
  titleVisibilitySlide: "Zichtbaarheid van de dia",
  titleVisibilityDashboard: "Dashboardzichtbaarheid",
  notifyNewDashboard: "Een nieuw dashboard ",
  notifyAtYourDisposal: " staat tot uw beschikking",
  notifyNewSlide: "Een nieuw slide ",
  notifyUsingUa:
    "Waarschuwing: deze link is niet langer functioneel. Gelieve in te loggen via deze link: ",
  notifyNewSlides: "Nieuwe dia's staan ​​tot uw beschikking ",
  notifyNewDashboards: " Nieuwe dashboards staan ​​tot uw beschikking",
  notifyNewSharedDashboard: "Een nieuw gedeeld dashboard",
  notifyNewSharedDashboards:
    " Nieuwe gedeelde dashboards staan ​​tot uw beschikking",
  notifyNewSharedSlide: "Een nieuwe gedeelde dia ",
  notifyNewSharedSlides: " Nieuwe gedeelde dia's staan ​​tot uw beschikking",
  notifyNewImportedBalance:
    "Er wordt een nieuwe weegschaal geïmporteerd voor de klant ",
  notifyNewImportedBalances:
    "Nieuwe geïmporteerde weegschalen staan ​​tot uw beschikking",
  slideEditableInfos:
    "Deze dia wordt gedeeld met de andere organisaties die het recht hebben om het te gebruiken zoals het is",
  dashboardEditableInfos:
    "Dit dashboard wordt gedeeld met de andere organisaties die het recht hebben om het te gebruiken zoals het is",

  //Messages
  successfulAction: "Succesvolle actie",
  operationCompleted: "Actie uitgevoerd met succes",
  errorOccured: "Er is een fout opgetreden, Gelieve te proberen later.",
  searchByNameOrVATnumber: "Zoek op naam of BTW-nummer",
  searchBySlideName: "Zoeken op dianaam ...",
  searchByDashboardName: "Zoeken op dashboardnaam",
  searchByName: "Zoeken op naam",
  wip: "In ontwikkeling",
  notifUpdates: "Meldingen van updates",
  nothingToShow: "Niets om te laten zien",
  incorrectFile: "Geïmporteerd bestand is niet compatibel !",
  noPresentations: "Geen presentatie gevonden",
  pageNotFound: "Zou deze pagina kan niet gevonden!",
  nothingFound: "Oeps, Er zijn geen resultaten gevonden voor uw zoekopdracht",
  justSentToRecipients:
    "Sommige geselecteerde ontvangers hebben zojuist een e-mail ontvangen",
  moreExercicesRequired:
    "- Voor dit <b>balansmodel</b> zijn meer oefeningen nodig...",
  applyAuthorizationMessage:
    "Toestemming toepassen op geselecteerde gebruikers",
  Oops: "Oeps",
  notAvailable: "Niet beschikbaar",
  noResult: "niets gevonden",
  typeCategoryTitle: "Typ de titel van uw categorie (3 talen beschikbaar)",
  updateExercices: "trainingsconfiguratie is bijgewerkt",
  readyDashAssociate: "Dashboard klaar om te worden gekoppeld aan klanten",
  accessDenied: "Toegang geweigerd",
  dashboardNotFound: "Dashboard niet gevonden",
  organizationNotFound: "organisatie niet gevonden",
  recipientsNotFound: "geen ontvangers gevonden! voeg wat toe",
  emailModelsNotFound: "Geen mailmodellen gevonden! voeg alsjeblieft wat toe",
  goClientPage: "U kunt teruggaan naar de pagina Klantenlijst",
  noBalanceImported: "Geen geïmporteerd saldo",
  noBalanceImportedMessage:
    "Tot op heden is er geen saldo ingevoerd. Als u vragen heeft over uw dossier, neem dan contact op met uw manager",
  sendSuccess: "succesvol verzenden",
  mailSent: "E-mail succesvol verzonden",
  importBalanceSuccess: "balansimport wordt met succes uitgevoerd",
  importAnnexeSuccess: "de bijlage import is succesvol uitgevoerd",
  updateAssociationSuccess: "de vereniging wordt met succes uitgevoerd",
  definePresentationDate: "Stel een presentatiedatum in",
  selectPresentationDate: "Selecteer een presentatiedatum...",
  presentationPreparedQuestion: "Presentatie voorbereid ?",
  presentationPresentedQuestion: "Gepresenteerd aan de klant ?",
  setPresentationState: "Markeer de staat van de presentatie",
  slideSaved: "Dia succesvol opgeslagen",
  deleteComponentConfirm: "Wilt u dit onderdeel verwijderen ?",
  cancelConfirmContent: "Wijzigingen worden geannuleerd.",
  cancelConfirm: "Wilt u annuleren?",
  exitConfirm: "Wil jij er uit?",
  deleteConfirm: "Wil je stoppen?",
  sharedConfirm: "Wil je delen?",
  deleteConfirmContent: "dashboard wordt verwijderd",
  deleteSlideConfirmContent: "Dia wordt verwijderd",
  sharedSlideConfirmContent: "Dia wordt gedeeld",
  duplicatedSlideConfirmContent: "Dia wordt gedupliceerd",
  saveSuccess: "Backup succesvol",
  importSuccess: "Import succesvol",
  removeSuccess: "Verwijderen is geslaagd",
  dashboardDeleted: "Dashboard verwijderd",
  deleteDashboardSuccess: "Dashboard succesvol verwijderd",
  dashboardDuplicated: "dashboard dupliceren",
  duplicateDashboardSuccess: "Dashboard dupliceert met succes",
  slideDuplicated: "slide dupliceren",
  slideAdded: "dia toegevoegd",
  addDashboardSuccess: "dashboard dupliceert met succes",
  dashboardAdded: "dashboard toegevoegd",
  duplicateSlideSuccess: "slide dupliceert met succes",
  addSlideSuccess: "voeg Dia Succes toe",
  slideDeleted: "Dia verwijderd",
  slideDeletedSuccess: "Dia verwijderd",
  slideSharedSuccess: "Dia succesvol gedeeld",
  slideShared: "Gedeelde dia",
  successUpdated: "Succesvol geüpdatet",
  categoryUpdated: "Categorie bijgewerkt",
  categoryAdded: "Categorie toegevoegd",
  categoryDeleted: "Categorie verwijderd",
  explanationAdded: "uitleg toegevoegd",
  explanationDeleted: "uitleg verwijderd",
  commentDeleted: "Reactie verwijderd",
  commentUpdated: "commentaar succesvol bijgewerkt",
  commentNull: "commentaar leeg",
  explanationUpdated: "uitleg succesvol aangepast",
  explanationSaved: "uitleg succesvol opgeslagen",
  annexeDeleted: "Bijlage geschrapt",
  deleteConfirmation: "Verwijdering bevestiging",
  deleteExplanationContent: "Weet u zeker dat u deze uitleg wilt verwijderen?",
  deleteCategoryContent:
    "Weet je zeker dat je deze categorie wilt verwijderen?",
  deleteAnnexeContent: "Weet u zeker dat u deze bijlage wilt verwijderen?",
  deleteCommentContent: "Weet je zeker dat je deze opmerking wilt verwijderen?",
  categoriesStateUpdated: "Status van categorieën bijgewerkt",
  mainAnnexeUpdated: "Hoofdbijlage bijgewerkt",
  hiddenAnnexeUpdated: "Verborgen bijlage bijgewerkt",
  certifiedAnnexeUpdated: "Annexe certification updated",
  addAnnexes: "Voeg een bijlage toe",
  importAnnexeSub: "Importeer bijlagen die de categories en het jaar aangeven",
  updateSuccess: "Bijgewerkt met succes",
  deleteExtraSlide: "Extra dia wordt verwijderd",
  extraSlideDeleted: "Extra dia succesvol verwijderd",
  accessRole: "je profiel geeft je geen toegang tot deze optie",
  gotLost: "Je bent zo snel gegaan en bent verdwaald...",
  specialAssociationMessage:
    "Dit model is rechtstreeks verbonden met het bedrijf",
  createdAssociationMessage:
    "Dit model wordt geassocieerd met de rechtsvorm van het bedrijf",
  defaultAssociationMessage: "Dit model is standaard gekoppeld",
  noBalance: "Geen saldo is geïmporteerd voor deze organisatie.",
  importInProgress: "Bezig met importeren van saldo. Een ogenblik geduld ...",
  dragFile:
    "Sleep een bestand hiernaartoe of klik om het te downloaden bestand te selecteren.",
  dragFiles:
    "Sleep een bestand hiernaartoe of klik om het te downloaden bestand te selecteren.",
  componentNotAvailable: "Component niet beschikbaar",
  duplicateSlideContent: "wil je deze dia toevoegen aan mijn sjablonen?",
  addSlideContent: "wil je deze dia toevoegen aan mijn sjablonen?",
  useSharedSlideContent:
    "wil je deze dia gebruiken ? (Let op: het gekozen model kan niet worden gewijzigd)",
  addDashboardContent: "wil je deze dashboard toevoegen aan mijn sjablonen ?",
  useSharedDashboardContent:
    "wil je dit dashboard gebruiken ? (Let op: het gekozen model kan niet worden gewijzigd)",
  duplicateDashboardContent: "wil je dit dashboard dupliceren?",
  categoryCreated: "categorie gemaakt",
  visibilityUpdated: "Zichtbaarheid bijgewerkt",
  confirmationDeleteCategoryMessage:
    "Wil je de categorie verwijderen <br> dan is het mogelijk om aan extra dia's te worden gekoppeld ?",
  confirmationDeleteCategoryTitle: "Bevestiging van verwijdering",
  noConfiguredExercice:
    "Balansoefeningenzijn nog niet geconfigureerd voor deze organisatie.",
  incompleteOperation:
    "Kan de operatie niet voltooien, onjuiste gegevens zijn ingediend",
  slideAlreadyUsedDeleteError:
    "Dia kan niet worden verwijderd, deze wordt gebruikt door een andere organisatie",
  slideAlreadyUsed:
    "Dia kan niet worden bijgewerkt, wordt gebruikt door een andere organisatie",
  dashboardAlreadyUsedDeleteError:
    "Dashboard kan niet worden verwijderd, het wordt gebruikt door een andere organisatie",
  dashboardAlreadyUsed:
    "Dashboard kan niet worden bijgewerkt, het wordt gebruikt door een andere organisatie",
  incompleteInfo:
    "niet in staat om het onderdeel op te slaan, moet u alle vereiste informatie aangeven",
  incompatibleModel:
    "Het geïmporteerde bestand komt niet overeen met het gekozen model !",
  kluwerFiveYearsModelDescription:
    "Dit model bevat 5 oefeningen geïmporteerd door de oefeningen hieronder te matchen en de oefeningen uit het te importeren bestand",
  kluwerTwoYearsModelDescription:
    "Dit model bevat 2 oefeningen geïmporteerd door de oefeningen hieronder te matchen en de oefeningen uit het te importeren bestand",
  kluwerOneYearModelDescription:
    "Dit model importeert slechts 1 oefening die hieronder wordt vermeld",
  kluwercomparedModelDescription:
    "Met dit model kun je 1 tot 5 oefeningen importeren. Zijn bijzonderheid is gebaseerd op het feit dat dit het enige model is waarmee u een jaarlijks boekjaar kunt importeren dat bestaat uit meer dan 4 periodes (12 maanden)",
  winbooksModelDescription:
    "Dit model importeert slechts 1 oefening die hieronder wordt vermeld",
  multipleModelDescription: "Deze sjabloon importeert een of meer oefeningen ",
  applicationNotActivated:
    "Accounting-applicatie is niet Geactiveerd voor de huidige organisatie.",
  applicationNotActivatedIndication:
    "Voor meer informatie kunt u contact met ons opnemen.",
  about_us_content:
    "is een geheel van tools die een bepaalde groep toelaat om te communiceren, uitwisselen, organiseren en doeltreffend samenwerken. Het platform bevat verschillende applicaties samengevoegd naargelang de noden van de klant. Dankzij deze tools, beschikken onze klanten over de laatste technologie.",
  annexeNotAvailable: "Deze bijlage is niet beschikbaar voor deze organisatie.",
  actionsOnExplinations: "Voeg uw uitleg toe, werk ze bij of verwijder ze",
  actionsOnCategories: "Voeg uw categorieën toe, activeer of deactiveer ze",
  listCommunity: "Lijst van ledencommunitys",
  communityUnauthorised:
    "Deze community heeft geen toegang tot deze applicatie",
  noRightsForOperations: "U heeft niet de rechten voor de gevraagde bewerking",
  choiceModelEmail: "Kies een e-mailsjabloon om naar de klant te sturen",
  alertHistoryMessage:
    "Er zijn al een of meer e-mails verzonden voor deze presentatie, scroll voor meer details:",
  msgEmptyField: "Voer de titel van de dia in (minstens één taal).",
  dashboardSharedSuccess: "Dashboard succesvol gedeeld",
  dashboardShared: "Gedeeld dashboard",
  sharedSlideContent: "Wil je deze dia delen ?",
  sharedDashboardContent: "Wil je dit dashboard delen ?",
  visibilitySlideContent: "Wilt u deze dia privé maken ?",
  visibilityDashboardContent: "Wilt u dit dashboard privé maken ?",
  slidePrivateSuccess: "Privaat dia",
  dashboardPrivateSuccess: "Privaat Dashboard",

  // ENUM
  ACTIVATED: "GEACTIVEERD",
  DEACTIVATED: "UITGESCHAKELD",

  ADMIN: "Beheerder",
  USER: "Gebruiker",
  NONE: "Geen",
  EDITOR: "Uitgever",
  LEGAL_REPRESENTATIVE: "Wettelijke vertegenwoordiger",
  OFFICIAL: "Officieel",
  EXTERNAL: "Extern",
  MANAGER: "Manager",
  COLLABORATOR: "Medewerker",
  SUPERVISOR: "Leidinggevende",

  READY: "KLAAR",
  PENDING: "IN AFWACHTING",
  CONFIGURED: "GECONFIGUREERD",
  NOT_CONFIGURED: "NIET GECONFIGUREERD",
  NO_ANNEXES: "ZONDER APPENDIX",

  gd: "klant manager",
  ge: "Coderingsmanager",
  es: "Encoding Supervisor",
  super: "leidinggevende",
  scan: "Scanoperator",

  white: "wit",
  bleu: "Blauw",

  Activated: "Geactiveerd",
  Disabled: "Gehandicapt",

  French: "Frans",
  English: "Engels",
  Dutch: "Nederlands",

  Ready: "Klaar",
  Configured: "geconfigureerd",
  Pending: "In afwachting",

  Synchronizing: "Datum laatste synchronisatie",

  Confirm: "Ja, ik heb het begrepen",

  UploadConfirm: "Invoer bevestigen",
  UploadConfirmContent:
    "Waarschuwing! Weegschalen die door synchronisatie worden bediend, gaan verloren.",

  RequestSyncing: "Verzoek om Synchronisatie",
  RequestSyncingContent: "synchronisatieverzoek is succesvol uitgevoerd",
  Syncing: "In synchronisatie",
  WaitingSync: "Wachten op synchronisatie",
  fullScreen: "Volledig scherm"
};



// WEBPACK FOOTER //
// ./src/i18n/nl.js